'use strict';

var util = angular.module('gymsystem.util');

util.controller('EntrySetting', ['$scope', '$http', 'fileManager', 'Setting', 'alertProvider',
    function($scope, $http, fileManager, Setting, alertProvider) {

    $scope.data = {};
    $scope.prev = {};

    var fields = ['welcome_sound', 'denied_sound', 'birthday_sound', 'show_card', 'xentry_wb', 'cardusetime'];
    var audioKeys = ['welcome', 'denied', 'birthday'];

    $scope.isChanged = function() {
        return fields.some(function(k) {
            return $scope.data[k] != $scope.prev[k];
        });
    };

    $scope.cardusetimeCorrect = function() {
        var d = $scope.data.cardusetime;
        var m = d && d.match('[0-9]+\:[0-9]+\:[0-9]+');
        return m && m.length == 1 && m[0] == d;
    };

    Setting.get('Entry').then(function(data) {
        $scope.data = data;
        $scope.prev = _.clone(data);

        audioKeys.forEach(function(key) {
            if(!$scope.data[key + '_sound']) {return;}
            fileManager.getFileByKey($scope.data[key + '_sound']).then(function(file) {
                $scope.data[key + 'FileName'] = file.name;
            });
        });
    });

    $scope.change = function(kind) {
        fileManager.chooseFile({
            originType: 'entry',
            mimeType: 'audio/*',
            visibleTabs: ['files', 'all']
        }).then(function(file) {
            $scope.data[kind + 'FileName'] = file.name;
            $scope.data[kind + '_sound'] = file.key;

            if($scope.sound[kind].audio) {
                $scope.sound[kind].audio.pause();
                $scope.sound[kind].audio = null;
            }

            $scope.prev[kind + 'FileName'] = file.name;
            $scope.prev[kind + '_sound'] = file.key;
            $scope.loading = true;
            Setting.set('Entry', $scope.prev).then(function() {
                alertProvider.show('success', 'Settings saved');
                $scope.loading = false;
            }, function() {
                alertProvider.show('error', 'Failed to save settings');
                $scope.loading = false;
            });
        });
    };

    $scope.sound = {welcome:{}, denied:{}, birthday:{}};
    $scope.playSound = function(kind) {
        var sound = $scope.sound[kind];
        var link = '/api/utils/file/download?key=' + $scope.data[kind + '_sound'];

        if(sound.audio) {
            sound.audio.pause();
            sound.audio = null;
            return;
        }
        if(sound.playing) {return;}
        sound.audio = new Audio(link);
        sound.audio.play();
        sound.audio.addEventListener("ended", function() {
            sound.audio = null;
            $scope.$digest();
        });
    };
    $scope.$on('$destroy', function() {
        audioKeys.forEach(function(key) {
            if($scope.sound[key].audio) {
                $scope.sound[key].audio.pause();
                $scope.sound[key].audio = null;
            }
        });
    });


    $scope.save = function() {
        $scope.loading = true;
        var data = {};
        fields.forEach(function(k) {
            data[k] = $scope.data[k];
        });
        Setting.set('Entry', data).then(function() {
            $scope.prev = _.clone($scope.data);
            alertProvider.show('success', 'Settings saved');
            $scope.loading = false;
        }, function() {
            alertProvider.show('error', 'Failed to save settings');
            $scope.loading = false;
        });
    };

}]);
